import { connect } from 'react-redux'
import ServiceEditMainInfo from '../../components/services/edit/ServiceEditMainInfo'
import { createService, updateService } from '../../state/actions/services/index'
import { getService } from '../../state/reducers/services'
import { IServiceCreateObject, IServiceUpdateObject, IStoreState } from '../../types/index'
import { fetchServicePrograms } from '../../state/actions/service-program/service-program'
import { getAllServicePrograms, getServiceProgram } from '../../state/reducers/service-program/service-program'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  const serviceId = ownProps.serviceId ? ownProps.serviceId : state.service.metadata.edit.serviceId
  const service = getService(state, serviceId)
  const serviceProgram =
    service && service.serviceProgram ? getServiceProgram(state, service.serviceProgram) : undefined
  return {
    serviceId,
    serviceProgram,
    service,
    userId: state.user.currentUserId,
    orgId: state.organizations ? state.organizations.currentOrgId : undefined,
    category: undefined,
    servicePrograms: getAllServicePrograms(state),
    onStepSuccessfullyCompleted: ownProps.onStepSuccessfullyCompleted,
    formRef: ownProps.formRef
  }
}

const mapDispatchToProps = (dispatch: any): any => {
  return {
    onComponentMount: () => {
      dispatch(fetchServicePrograms())
    },
    onComponentSubmit: (service: IServiceCreateObject | IServiceUpdateObject) => {
      if (service.hasOwnProperty('id')) {
        return dispatch(updateService(service as IServiceUpdateObject))
      } else {
        return dispatch(createService(service as IServiceCreateObject))
      }
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceEditMainInfo)



// WEBPACK FOOTER //
// ./src/containers/services/ServiceEditMainInfo.ts